import React from 'react';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import {connect} from 'react-redux';
import { sortedCategories } from '../reducer';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import shallowCompare from 'react-addons-shallow-compare';
import Bookmark from 'material-ui/svg-icons/action/bookmark';
import AnswerEditModal from '../components/AnswerEditModal';
import {saveAnswerNote, saveAnswer, toggleQuestionFlagged} from '../actions/response';
import {questionsAndAnswers} from '../reducer';
import {getResponse} from '../reducer/response';
import {domainLogicToCounts} from '../reducer/response';
import InfluenceAvatar from '../components/InfluenceAvatar';
import BackgroundSyncStatusBar from "../components/BackgroundSyncStatusBar";
import NoteIcon from "material-ui/svg-icons/action/find-in-page";
import {noteIconColor} from "../components/resultItems/Notes";
import {fetchTranslation} from '../actions/translation';

//TODO: use smae name structure in all places
export const SECTION_TITLES = {
  monitoring: "Data Collection",
  assessment: "Assessment",
  controlRules: "Management Measures",
  enforcement: "Enforcement"
}

export const byCategory = (category) => {
  return (question) => question.category === category.id
}

class AnswersList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      answerEditorOpen: false,
      question: null,
      answer: null
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidMount() {
    if(this.props.response.userEdits.trIDForResponse && this.props.response.userEdits.trIDForResponse !== -1 && !this.props.translation){
      this.props.fetchTranslation(this.props.response.userEdits.trIDForResponse)
    }
  }

  render() {
    let {sections, answers, saveAnswer, toggleFlagged} = this.props;
    answers = answers || {};
    return  (
      <div>

        {
          sections.map((section) => (
            <Card key={section} style={{maxWidth: 800, margin: "0px auto", marginBottom: 20}}>
              <BackgroundSyncStatusBar hidden={false} />
              <CardText
                style={{
                  textAlign: "right",
                  marginBottom: -44,
                  position: "relative",
                  zIndex: 1
                }}
              >
              </CardText>
              <CardTitle title={SECTION_TITLES[section] + " Answers"} /> {/*TODO: Translate, see QuestionPageHeader for  structure, copy into section_titles??*/}

              <List>
              {
                this.props.categories.map((c) => {
                  let categoryQuestions = this.props[`${section}Questions`].filter(byCategory(c));
                  if (categoryQuestions.length) {
                    let catTitle = c.title
                    if(this.props.translation){
                      let trCat = this.props.translation.categories.find(trcat => trcat.engID === c.id)
                      catTitle = trCat ? trCat.title : c.title;
                    }
                    return (
                      <div key={c.id}>
                        <Subheader>{catTitle}</Subheader>
                        {
                          categoryQuestions.map((question) => {
                            let answer = answers[question.id];
                            let avatar = !!answer ?  <InfluenceAvatar display={section !== 'assessment' ? "Caveat" : "Criteria"} {...domainLogicToCounts(question, answer.value)} /> : <span />
                            let rightIcon = null;
                            if (answer && answer.note && question.flagged) {
                              rightIcon = <div style={{display:"flex", width:48}}><Bookmark color="green" /><NoteIcon color={noteIconColor} /></div>
                            }else if (answer && answer.note){
                              rightIcon = <NoteIcon color={noteIconColor} />;
                            }else if (question.flagged){
                              rightIcon = <Bookmark color="green" />;
                            }

                            let qTitle = question.title
                            let answerText = question.answerText
                            if(this.props.translation){
                              var trQ = this.props.translation.questions.find(trQ => trQ.engID === question.id)
                              if(trQ){
                                  qTitle = trQ.title
                                  if(answer){
                                    answerText = trQ.answers.find(a => a.id === answer.value).title
                                  }
                              }
                            }

                            return (
                              <ListItem style={answerText ? {} : {backgroundColor: "#efefef"}} onClick={this.onClick.bind(this, question, answer, trQ)} leftAvatar={avatar} key={question.id} primaryText={qTitle.replace(/<.*?>/gm, '')} secondaryText={answerText || <span style={{fontStyle: "italic", color: "rgb(184, 66, 66)"}}>No answer given</span>} rightIcon={rightIcon} />
                            )
                          })
                        }
                        <Divider />
                      </div>
                    )
                  } else {
                    return null;
                  }
                })
              }
              </List>
            </Card>
          ))
        }
        <AnswerEditModal
          response={this.props.response}
          readOnly={this.props.readOnly}
          open={this.state.answerEditorOpen}
          question={this.state.question}
          answer={this.state.answer}
          trQuestion={this.state.trQuestion}
          onRequestClose={this.onClose.bind(this)}
          onSave={saveAnswer}
          onSaveNote={this.handleSaveNote}
          onToggleFlagged={toggleFlagged}
          section={this.state.section}
        />
      </div>
    );
  }

  handleSaveNote = (id, value, response) => {
    this.props.saveNote(id,value,response);
    this.setState({answer: {
      ...this.state.answer,
      note: value
    }});
  }

  onClick(question, answer, trQuestion) {
    this.setState({
      answerEditorOpen: true,
      question: question,
      answer: answer,
      trQuestion: trQuestion
    })
  }

  onClose() {
    this.setState({
      answerEditorOpen: false
    })
  }
}

let sections = ['monitoring', 'assessment', 'controlRules', 'enforcement'];

let mapStateToProps = (state, ownProps) => {
  let responseID = ownProps.params.id;
  let response = getResponse(state)
  let readOnly = response.email !== state.auth.email && !state.auth.isAdmin;
  let answers = response.answers;
  let trIDForResponse = response.userEdits ? response.userEdits.trIDForResponse : -1;
  let translation = (trIDForResponse !== -1) ? state.translations.find((t) => t.id === trIDForResponse) : null;
  return {
    categories: sortedCategories(state),
    answers: answers,
    sections: sections,
    readOnly: readOnly,
    fetchingResponse: state.responses.fetching,
    responseID: responseID,
    monitoringQuestions: questionsAndAnswers.monitoring(state),
    assessmentQuestions: questionsAndAnswers.assessment(state),
    controlRulesQuestions: questionsAndAnswers.controlRules(state),
    enforcementQuestions: questionsAndAnswers.enforcement(state),
    response: response,
    translation: translation
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    saveAnswer: (id, value, section, response) => dispatch(saveAnswer(id, value, section, response)),
    toggleFlagged: (id, response) => dispatch(toggleQuestionFlagged(id, response)),
    saveNote: (id, value, response) => {
      dispatch(saveAnswerNote(id, value, response));
    },
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnswersList));
